import { Component, OnInit, Input } from '@angular/core';
import {TreatyApiService} from "../../services/treaty.service";
import {NewsItemViewModel} from "../../models/treaty.models";

@Component({
    standalone: false,
    selector: 'particle-treaty-news-viewer',
  templateUrl: './treaty-news-viewer.component.html',
  styleUrls: ['./treaty-news-viewer.component.scss']
})
export class TreatyNewsViewerComponent implements OnInit {
  treatyNewsInfos: NewsItemViewModel[];
  @Input() id: string;
  @Input() id1: string;
  @Input() id2: string;
  constructor(private treatyService: TreatyApiService) { }

  ngOnInit() {
    console.log(this.id1);
    if(this.id != null ) {
      this.treatyService.getTreatyParentNewsInfoById(this.id).subscribe((data) => {
        this.treatyNewsInfos = data;
      });
    }
    else{
      this.treatyService.getTreatyChildNews(this.id1, this.id2).subscribe((data) =>{
        this.treatyNewsInfos = data;
      });
    }
    console.log(this.treatyNewsInfos);
  }

}
